var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2840",
    "data-name": "Grupo 2840",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1392",
    "data-name": "Ret\\xE2ngulo 1392",
    width: 35,
    height: 35,
    rx: 10,
    fill: "#cfcfcf",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Message",
    "data-name": "Iconly Two-tone Message",
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M1992.668,1646.912l-4.266,3.434a2.223,2.223,0,0,1-2.746,0l-4.3-3.434",
    transform: "translate(-1977.4 -1641.351)",
    fill: "none",
    stroke: "#cfcfcf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    d: "M1982.288,1641.351h9.428a4.956,4.956,0,0,1,3.584,1.59,5.015,5.015,0,0,1,1.326,3.7v6.528a5.016,5.016,0,0,1-1.326,3.7,4.956,4.956,0,0,1-3.58,1.59h-9.432c-2.92.008-4.888-2.367-4.888-5.286v-6.528C1977.4,1643.726,1979.368,1641.351,1982.288,1641.351Z",
    transform: "translate(-1977.4 -1641.351)",
    fill: "none",
    stroke: "#cfcfcf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.442826caaa609dc6f9c26a93fac7653c.svg";
export { ForwardRef as ReactComponent };